import React from 'react';
import { GenericFilterBadge, FilterBadgeDataItem } from './generic-filter-badge';
import { PartnershipAdsBadgeProps } from './types';

const PartnershipAdsBadge = React.forwardRef<HTMLDivElement, PartnershipAdsBadgeProps>(
  ({ children: _children, className, data, onDismiss, ...props }, ref) => {
    const getDisplayText = (item: FilterBadgeDataItem) => item.label || '';

    const getTooltipValue = () => 'Comparing ads with "Partnership Ads" toggle enabled in Meta for Aspire\'s content';

    return (
      <GenericFilterBadge
        ref={ref}
        data={data}
        onDismiss={onDismiss}
        label=""
        tooltipTitle="Partnership Ads Comparison"
        tooltipKey="Status"
        ariaLabel="Partnership ads comparison filter"
        dismissAriaLabel="Remove partnership ads comparison filter"
        srOnlyText="Remove partnership ads comparison filter"
        getDisplayText={getDisplayText}
        getTooltipValue={getTooltipValue}
        showCount={false}
        badgeKey="partnership-ads-pill"
        className={className}
        {...props}
      />
    );
  },
);

PartnershipAdsBadge.displayName = 'PartnershipAdsBadge';

export { PartnershipAdsBadge };
